<div class="app-modal">
  <ng-content select="app-modal-content"></ng-content>
  <ng-content></ng-content>
  <ng-content select="app-modal-footer"></ng-content>
</div>
